<template>
    <FlexLayout role="region">
      <BlockContainer>
        <p>{{ $t('forgotPassword.label.info') }}</p>
        <Input
          id="emailAddr"
          :label="$t('field.email')"
          type="email"
          v-model="$v.form.emailAddr.$model"
          :error="$v.form.emailAddr.$dirty && $v.form.emailAddr.$error ? $t('validation.invalidEmail') : ''"
          :required="true"
          :maxlength="config.CUSTOMER_DATA.FIELDS.emailAddr.maxLength"
          aria-describedby="login-form-email"
        />
        <template #actions>
          <Button type="submit" @click.stop="onClickCaptcha" :disabled="submitStatus === 'PENDING' || $v.$invalid" variant="primary">{{ $t('forgotPassword.button.reset') }}</Button>
        </template>
      </BlockContainer>
    </FlexLayout>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import {accountService} from "../../services/api/accountService";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import Input from "@/components/forms/Input.vue";
import Button from "@/components/actions/Button.vue";

export default {
  components: {Button, Input, BlockContainer, FlexLayout},
     data() {
       return {
         form: {
           emailAddr: undefined,
         },
         submitStatus: null,
         responseToken: "",
       }
     },
    computed: {
      config() {
        return window.config;
      },
    },
    validations: {
      form: {
        emailAddr: {
          required,
          email,
        },
      },
    },
    methods: {
        // eslint-disable-next-line no-undef
        onClickCaptcha(e) {
            console.debug("onClickCaptcha");
            e.preventDefault();
            if(window.config.G_CAPTCHA.enabled == true)
            {
                // eslint-disable-next-line no-undef
                grecaptcha.ready(function() {
                    // eslint-disable-next-line no-undef
                    grecaptcha.execute(window.config.G_CAPTCHA.siteKey, {action: 'submit'}).then(function(token) {
                        this.responseToken = token;
                        this.onSubmit(e);
                    });
                });
            }
            else
            {
                this.onSubmit(e);
            }

        },
       onSubmit: async function (event) {
         event.preventDefault();

         this.$v.$touch();
         if (this.$v.$invalid) {
           this.submitStatus = 'ERROR';
           return;
         } else {
           this.submitStatus = 'OK'
         }

         await accountService.resetPassword(this.form.emailAddr, this.responseToken);

         // Show toast and trigger a callback for navigation
         this.makeToast(
             'success',
             this.$t('forgotPassword.messages.info.onForgotPassword'),
             this.$navigateToLogin
         );
       },
  },
}
</script>
